<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Charge') !== -1" (click)="openChargeDetails()">
    Charge {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('PaymentGroup') !== -1" (click)="openPaymentGroupDetails()">
    Payment {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Category') !== -1" (click)="openEditCategory()">
    Category {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Asset') !== -1" (click)="openEditAccount('asset')">
    Asset {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Liability') !== -1" (click)="openEditAccount('liability')">
    Liability {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Equity') !== -1" (click)="openEditAccount('equity')">
    Equity {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('Transaction') !== -1" (click)="openViewTransaction()">
    Transaction {{ reference?.id }}
</button>

<button class="btn btn-link text-left p-0 m-0" *ngIf="reference?.type.indexOf('StripeRefund') !== -1 && reference?.paymentGroupId" (click)="openRefundPaymentDetails()">
    Refund {{ reference?.id }}
</button>
